   
   @if(label?.length)
   {
     <label
        for="contactNumber"
        class="{{labelClass}}">
        {{ label }}
      </label>
   }

<div class="flex w-full p-0 {{floatLabel ? 'p-float-label' : ''}} {{containerStyleClass || 'align-items-center'}}">

  <p-select
    styleClass="{{flagDropdownStyle ? flagDropdownStyle : 'flag-dropdown'}}"
    [options]="countries"
    optionLabel="name"
    [(ngModel)]="selectedCountry"
    [ngModelOptions]="{ standalone: true }"
    (onChange)="onCountryChange($event)"
    [readonly]="readonly"
    [disabled]="disabled"
    appendTo="body"
    class="rounded-xl border-none bg-transparent align-items-center">
    <ng-template #item let-country>
      <div class="flex align-items-center flag-list-item">
        <img
          src="assets/images/flags/{{ country?.flag }}"
          [alt]="country.name"
          [width]="30"
          [height]="20"
          style=" margin-right:8px;" />
        <span>{{ country?.name }} <span class="opacity-50">{{ country.countryCode }}</span></span>
      </div>
    </ng-template>

    <ng-template #selectedItem let-country>
      <div class="flex align-items-center">
        <img
          src="assets/images/flags/{{ country?.flag }}"
          alt="{{ country?.name }}"
          [width]="30"
          [height]="20"
          style="width: 36px"
        />
      </div>
    </ng-template>
  </p-select>

  <span class="number-input-container w-full">
    <p-inputmask
      id="contactNumber"
      class="flex h-full"
      [readonly]="readonly"
      [required]="required"
      [mask]="mask"
      [(ngModel)]="phoneNumber"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onInputChange($event)"
      (onFocus)="onFocus()"
      (onBlur)="onTouched(); onBlur()"
      [disabled]="disabled"
      appCustomCursorPosition
      autocomplete="tel"
      inputmode="tel"
      size="30"
      [styleClass]="'custom-input ' + inputStyleClass"
      type="tel"
      placeholder="{{!floatLabel ? placeholder || label : ''}}"
    >
    </p-inputmask>
  </span>
</div>
